import { Injectable } from '@angular/core';
import { Rilevazione } from '../models/rilevazione-presenze/rilevazione';
import { Presenza } from '../models/rilevazione-presenze/presenza';
import { AttivitaReale } from '../models/didattica/attivita-reale';
import { Delega } from '../models/rilevazione-presenze/delega';
import { StudenteProgress } from '../models/didattica/studente-progress';
import { Studente } from '../models/didattica/studente';
import { Prenotato } from '../models/student-booking.models';
import { Docente } from '../models/didattica/docente';
import { Idoneita } from '../models/idoneita/idoneita';
import { IdoneitaStudente } from '../models/idoneita/Idoneita-studente';
import { Inoltro } from '../models/inoltro';
import { StudenteClasse } from '../models/registro/studente-classe';
import { GruppoStudenti } from '../models/registro/gruppo-studenti';
import { StudenteEnanche } from '../models/didattica/studente-enanche';

/**
 * Fornisce servizi di storage per la navigazione
*/
@Injectable( { providedIn: 'root' })
export class DataService {

  public rilevazione: Rilevazione;
  public presenza: Presenza;
  public attivitaReale: AttivitaReale;
  public delega: Delega;
  public presenze: Presenza[];
  public studentProgress: StudenteProgress;
  public studente: Studente;
  public stud: StudenteEnanche;
  public prenotati: Prenotato[];
  public showprenotati: boolean;
  public docente: Docente;
  public idoneita: Idoneita;
  public idoneitaStudenti: IdoneitaStudente[];
  public inoltro: Inoltro;
  public studentiClasse: StudenteClasse[];
  public gruppiStudenti: GruppoStudenti[];

  constructor( ) {
    console.log('Hello DataService Provider');
  }

}
